import { shallowMount } from "@vue/test-utils";
import Paso2 from "@/views/Paso2";

describe("Paso2 component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Paso2, {
      propsData: {
        embeded: false
      }
    });
  });

  it("Renders del component Paso2", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
